import React, { FC } from 'react';

const BikeIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="23"
    viewBox="0 0 13 23"
  >
    <rect width="13" height="23" fill="#fff" opacity="0" />
    <path
      d="M3.5,10.5l.9-2.2a1,1,0,0,1,.9-.7H6.5v1H5.3l-.7,1.9H6.9V10H6.5V9.1H8.9V10H8.1l-.9,2.4h.3a2.3,2.3,0,0,1,2.2-1.9,2.4,2.4,0,0,1,2.5,2.4,2.3,2.3,0,0,1-2.3,2.4,2.4,2.4,0,0,1-2.4-1.9h-2a2.5,2.5,0,0,1-2.2,1.9A2.5,2.5,0,0,1,.8,12.9a2.3,2.3,0,0,1,2.3-2.4Zm5,2.9a1.5,1.5,0,0,0,1.4.9,1.4,1.4,0,0,0,0-2.8,1.5,1.5,0,0,0-1.4.9H9.9v1Zm-3-1h.7l.3-.9H5.1A2.5,2.5,0,0,1,5.5,12.4ZM3.1,14.3a1.4,1.4,0,0,0,1.5-1.4,1.4,1.4,0,0,0-.5-1.1l-.5,1.3-.9-.4.5-1.2H3.1a1.4,1.4,0,0,0,0,2.8Z"
      transform="translate(0)"
      fill="currentColor"
    />
  </svg>
);

export default BikeIcon;
